import React from "react";
import { SelectOption } from "./AddUser.types";
import "./AddUser.css";

interface SelectInputProps {
  label: string;
  name: string;
  formik: any;
  options: SelectOption[];
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  helperText?: string;
}

export const SelectInput: React.FC<SelectInputProps> = ({
  label,
  name,
  formik,
  options,
  placeholder,
  required,
  disabled,
  helperText,
}) => {
  const error = formik.touched[name] && formik.errors[name];

  return (
    <div>
      <label className="addUser-label">
        {label} {required && <span className="addUser-required">*</span>}
      </label>

      {helperText && <div className="addUser-helper-text">{helperText}</div>}

      <select
        name={name}
        disabled={disabled}
        value={formik.values[name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        className="addUser-select"
      >
        <option value="">{placeholder ?? "Select"}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <div className="addUser-error">{error ?? ""}</div>
    </div>
  );
};
